<ng-container *ngIf="isAccessTokenPage; else elseTemplate">
  <router-outlet></router-outlet>
</ng-container>

<ng-template #elseTemplate>
  <wm-libs-main-layout [app]="'wm-tech-pool'" [balance]="balance">
    <router-outlet></router-outlet>
  </wm-libs-main-layout>
</ng-template>
